<template>
  <el-dialog
    title="备注"
    :visible.sync="show"
    width="600px"
  >
    <div class="remark__content">
      <el-row>
        <el-col :span="24">订单号</el-col>
        <el-col :span="24">
          {{ useContent()  }}
        </el-col>
        <el-col :span="24">处理状态</el-col>
        <el-col :span="24">
          <el-radio-group v-model="handleState">
            <el-radio :label="1">未处理</el-radio>
            <el-radio :label="2">已处理</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="24">备注</el-col>
        <el-col :span="24">
          <el-input v-model="handleRemark" type="textarea" :rows="4" />
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="type" @click="$emit('update:visible',false)">取 消</el-button>
      <el-button size="type" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name:"UpdateOrderInfo",
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    orderIds:{
      type:Array,
      default:() => []
    }
  },
  data(){
    return {
      handleRemark:'',
      handleState:null
    }
  },
  computed:{
    show:{
      get(){
        return this.visible;
      },
      set(val){
        this.$emit('update:visible',val)
      }
    }
  },
  watch:{
    visible:{
      handler(val){
        this.handleRemark = '';
        this.handleState = null;
        !val && this.$emit('clearSelection');
      }
    },
  },
  methods:{
    useContent(){
      return this.orderIds.length > 3 ? `${this.orderIds[0]}...${this.orderIds.length}个订单` : this.orderIds.join(',');
    },
    async onConfirm(){
      try{
        if(!this.handleState) throw { msg:'请选择处理状态' }
        const { msg , code } = await this.$API.updateOrderInfo({
          handleRemark:this.handleRemark,
          handleState:this.handleState,
          orderId:this.orderIds.join(',')
        });
        if(code === 200) throw { msg };
        this.$message({
          type:'success',
          message:'修改成功'
        });
        this.$emit('update:visible',false);
        this.$emit('onSuccess');
      }catch({ msg }){
        this.$message({
          type:'warning',
          message:msg
        });
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.remark__content{
  .el-col{
    margin-bottom: 20px;
  }
}
</style>
